// ============================================================
// 「並び替え」機能（コレクション順 / いいね数順）
// 1ページに複数の商品一覧セクションがあっても、
// Firebaseへの通信は1回だけにまとめる。
// また、並び替えUIが存在しないページではFirebase自体を読み込まない。
// ============================================================

let dbPromise = null;
async function getDb() {
  if (!dbPromise) {
    dbPromise = (async () => {
      const { initializeApp, getApps } = await import('https://www.gstatic.com/firebasejs/10.12.0/firebase-app.js');
      const { getDatabase } = await import('https://www.gstatic.com/firebasejs/10.12.0/firebase-database.js');

      // like-button.liquidと同じ値を入れてください
      const FIREBASE_CONFIG = {
        apiKey: "AIzaSyBibdc-1C7VwDsP2I_wWne4r3fF1NbKp1s",
        authDomain: "shopify-likes-e0091.firebaseapp.com",
        databaseURL: "https://shopify-likes-e0091-default-rtdb.asia-southeast1.firebasedatabase.app/",
        projectId: "shopify-likes-e0091",
        storageBucket: "shopify-likes-e0091.firebasestorage.app",
        messagingSenderId: "714634741838",
        appId: "1:714634741838:web:e8f9b874b13be8d0af5b1f"
      };

      const app = getApps().length === 0 ? initializeApp(FIREBASE_CONFIG) : getApps()[0];
      return getDatabase(app);
    })();
  }
  return dbPromise;
}

let likesCache = null;
async function fetchAllLikes() {
  if (likesCache) return likesCache;
  try {
    const { ref, get } = await import('https://www.gstatic.com/firebasejs/10.12.0/firebase-database.js');
    const db = await getDb();
    const snapshot = await get(ref(db, 'likes'));
    likesCache = snapshot.exists() ? snapshot.val() : {};
    return likesCache;
  } catch (e) {
    return {};
  }
}

function getSectionContainer(sectionId) {
  return document.querySelector(
    `[data-testid="product-list"][data-section-id="${sectionId}"]`
  );
}

function getGridContainer(section) {
  const firstItem = section.querySelector('.resource-list__item');
  return firstItem ? firstItem.parentElement : null;
}

function getItems(container) {
  return Array.from(container.children).filter(el =>
    el.classList.contains('resource-list__item')
  );
}

function getProductId(item) {
  const el = item.querySelector('[data-product-id]');
  return el ? el.dataset.productId : null;
}

async function sortByLikes(container, items, maxItems) {
  const likesData = await fetchAllLikes();
  const sorted = [...items].sort((a, b) => {
    const countA = likesData[getProductId(a)] || 0;
    const countB = likesData[getProductId(b)] || 0;
    return countB - countA;
  });
  sorted.forEach((item, i) => {
    container.appendChild(item);
    if (maxItems > 0) {
      item.hidden = i >= maxItems;
    }
  });
}

function sortByDefault(container, items, maxItems) {
  const original = [...items].sort((a, b) =>
    (parseInt(a.dataset.originalOrder) || 0) - (parseInt(b.dataset.originalOrder) || 0)
  );
  original.forEach((item, i) => {
    container.appendChild(item);
    if (maxItems > 0) {
      item.hidden = i >= maxItems;
    }
  });
}

function initOneLikeSort(wrapper) {
  const sectionId = wrapper.dataset.sectionId;
  const section = getSectionContainer(sectionId);
  if (!section) return;

  const container = getGridContainer(section);
  if (!container) return;

  const maxItems = parseInt(wrapper.dataset.maxItems) || parseInt(section.dataset.maxItems) || 0;
  const defaultSortMode = wrapper.dataset.defaultSort === 'collection' ? 'collection' : 'likes';

  getItems(container).forEach((item, i) => { item.dataset.originalOrder = i; });

  initialSort(wrapper, container, maxItems, defaultSortMode);

  const trigger = wrapper.querySelector('.like-sort-trigger');
  const dropdown = wrapper.querySelector('.like-sort-dropdown');
  const options = wrapper.querySelectorAll('.like-sort-option');

  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = dropdown.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', isOpen);
  });

  document.addEventListener('click', () => {
    dropdown.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', false);
  });

  options.forEach(option => {
    option.addEventListener('click', async (e) => {
      e.stopPropagation();
      const value = option.dataset.value;

      options.forEach(o => {
        o.classList.remove('like-sort-option--selected');
        o.setAttribute('aria-selected', false);
      });
      option.classList.add('like-sort-option--selected');
      option.setAttribute('aria-selected', true);

      dropdown.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', false);

      const currentItems = getItems(container);
      if (value === 'likes') {
        trigger.style.opacity = '0.5';
        await sortByLikes(container, currentItems, maxItems);
        trigger.style.opacity = '1';
      } else {
        sortByDefault(container, currentItems, maxItems);
      }
    });
  });
}

// 初期表示：セクションごとの設定（コレクション順 / いいね数順）に従って並び替え
async function initialSort(wrapper, container, maxItems, defaultSortMode) {
  const trigger = wrapper.querySelector('.like-sort-trigger');
  if (defaultSortMode === 'collection') {
    sortByDefault(container, getItems(container), maxItems);
    return;
  }
  trigger.style.opacity = '0.5';
  await sortByLikes(container, getItems(container), maxItems);
  trigger.style.opacity = '1';
}

function initLikeSort() {
  const wrappers = document.querySelectorAll('.like-sort-wrapper:not([data-initialized])');
  if (wrappers.length === 0) return; // このページには並び替えUIが無いので何もしない
  wrappers.forEach(wrapper => {
    wrapper.dataset.initialized = 'true';
    initOneLikeSort(wrapper);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLikeSort);
} else {
  initLikeSort();
}

// テーマエディターでセクションを再読み込みした場合にも対応
document.addEventListener('shopify:section:load', initLikeSort);
